module.exports = __webpack_public_path__ + "img/131.6a018f20.jpg";